export const preProcessPayload = (payload: any) => {
    // Add any additional processing logic here
    let processedPayload = {
        ...payload,
        dedicatedSlotGroupFilter: payload?.activeFilterCard?.type || 'ALL',
    };
    if (!!payload?.searchText) {
        payload.searchText = payload.searchText.trim();
    } else {
        payload.searchText = '';
    }
    return processedPayload;
};
export const SLOT_FILTERS = Object.freeze({
    TOTAL: 'TOTAL',
    PEAK: 'PEAK',
    SLOTS_SHORTAGE: 'SLOTS_SHORTAGE',
});
export const SLOT_FILTER_CARDS = [
    {
        name: 'Total Slots',
        type: SLOT_FILTERS.TOTAL,
        filterValue: {
            type: 'ALL',
            subType: '',
        },
        valueMappingKey: 'totalSlots',
    },
    {
        name: 'Peak Slots',
        type: SLOT_FILTERS.PEAK,
        filterValue: {
            type: 'PEAK',
            subType: '',
        },
        valueMappingKey: 'peakSlots',
    },
    {
        name: 'Slots with Shortage',
        type: SLOT_FILTERS.SLOTS_SHORTAGE,
        filterValue: {
            type: 'SHORTAGE',
            subType: '',
        },
        valueMappingKey: 'slotsWithShortage',
    },
];
export const SLOT_TABLE_COLUMNS = [
    {
        name: 'Day / date',
        mappingKey: 'date',
    },
    {
        name: 'Segment',
        mappingKey: 'segment',
    },
    {
        name: 'Start time',
        mappingKey: 'startTime',
    },
    {
        name: 'End time',
        mappingKey: 'endTime',
    },
    {
        name: 'EPH',
        mappingKey: 'earningsPerHr',
    },
    {
        name: 'Staff Count / capacity',
        mappingKey: 'staffCount',
    },
    {
        name: '',
        mappingKey: 'action',
        actions: true,
    },
];

export const SLOT_TYPE_CLASS_TYPE_MAPPING: any = Object.freeze({
    PEAK: 'peak',
    NORMAL: 'normal',
});
